import { render, staticRenderFns } from "./validateImmPass.vue?vue&type=template&id=728d81f0&scoped=true&"
import script from "./validateImmPass.vue?vue&type=script&lang=js&"
export * from "./validateImmPass.vue?vue&type=script&lang=js&"
import style0 from "./validateImmPass.vue?vue&type=style&index=0&id=728d81f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d81f0",
  null
  
)

export default component.exports